import React from "react"
import { Col, Card, CardBody, Row } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import { getChartColorsArray } from "utils/chartColors"
import { useTranslation } from "react-i18next"

const colorsArray = [
  "--bs-success",
  "--bs-cyan",
  "--bs-primary",
  "--bs-secondary",
  "--bs-warning",
  "--bs-success",
]
const basicColor = [
  "success",
  "cyan",
  "primary",
  "secondary",
  "warning",
  "success",
]

const CustomerDistribution = () => {
  const { t } = useTranslation()

  const apexsalesAnalyticsChartColors = getChartColorsArray(colorsArray)
  const series = [8.7, 25.6, 32.0, 23.8, 9.9]
  const options = {
    labels: [
      t("customers_others"),
      t("customers_alWakrah"),
      t("customers_doha"),
      t("customers_alRayyan"),
      t("customers_alRayyan"),
    ],
    colors: apexsalesAnalyticsChartColors,
    legend: { show: !1 },

    dataLabels: {
      dropShadow: {
        enabled: false,
      },
    },
    plotOptions: {
      pie: {
        donut: {
          size: "60%",
          labels: {
            show: true,
            value: {
              show: true,
              dropShadow: {
                enabled: false,
              },
            },
          },
        },
      },
    },
  }
  return (
    <Col xl="4">
      <Card className="shadow-md rounded-3 h-100">
        <CardBody>
          <h4 className="card-title mb-4 text-capitalize">
            {t("customers_customerDistribution")}
          </h4>

          <div>
            <div id="donut-chart">
              <ReactApexChart
                options={options}
                series={series}
                type="donut"
                height={260}
                className="apex-charts"
              />
            </div>
          </div>

          <div className="text-center text-muted">
            <Row>
              {options.labels.map((label, index) => (
                <Col xs="4" key={index}>
                  <div className="mt-4 text-start">
                    <p className="mb-2 text-truncate">
                      <i
                        className={`mdi mdi-circle text-${basicColor[index]} me-1`}
                      />
                      {label}
                    </p>
                    <h5>{series[index]}</h5>
                  </div>
                </Col>
              ))}
            </Row>
          </div>
        </CardBody>
      </Card>
    </Col>
  )
}

export default CustomerDistribution
